"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Yahoo = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M22.667 2.667h-4.628l-4.1 10.02h4.593zM5.495 7.516H1.333L6.035 18.45 4.31 22.384h4.092l6.182-14.868h-4.022L8.02 13.945zm12.322 8.721a2.586 2.586 0 1 1-5.171 0 2.586 2.586 0 0 1 5.171 0"
    fill="#333"
  />,
  "Yahoo",
  { viewBox: "0 0 24 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
